<template>
  <div class="paginated-list">
    <div class="paginated-list-perPage">
      <span>Afficher par page:</span>
      <div class="select is-small">
        <select v-model="_perPage">
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="15">15</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
        </select>
      </div>
    </div>
    <div class="paginated-list-header"><slot name="search" /></div>
    <transition name="fade" mode="out-in">
      <div v-if="itemsCount > 0">
        <slot name="list-message" />
        <table class="table is-striped is-fullwidth is-small is-size-7">
          <thead>
            <tr>
              <slot name="table-headers" />
            </tr>
          </thead>
          <tbody>
            <lazy-component
              v-for="(paginatedItem, index) in paginatedItems"
              :key="paginatedItem.uuid || paginatedItem.id"
              tag="tr"
              class="paginated-list-row"
            >
              <slot
                name="paginated-listItem"
                :paginated-item="paginatedItem"
                :paginated-item-index="index"
              />
            </lazy-component>
          </tbody>
        </table>
        <hr />
        <Pagination
          :items-count="itemsCount"
          :per-page="perPage"
          :current-page="currentPage"
          @page-change="handlePageChange($event)"
        />
      </div>
      <Loader v-else-if="loading" />
      <EmptyList v-else />
    </transition>
  </div>
</template>

<script>
import EmptyList from "@/components/EmptyList";
import Loader from "@/components/Loader";
import Pagination from "@/components/Pagination";
import paginationUtil from "@/util/pagination";

export default {
  name: "PaginatedList",
  components: { EmptyList, Loader, Pagination },
  computed: {
    itemsCount() {
      return this.items.length;
    },
    paginatedItems() {
      return paginationUtil.paginate(
        this.items,
        this.currentPage,
        this.perPage
      );
    },
    _perPage: {
      get() {
        return this.perPage;
      },
      set(val) {
        this.$emit("update:perPage", val);
      }
    }
  },
  data() {
    return {
      direction: "",
      currentPage: 0
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    perPage: {
      type: Number,
      default: 5
    }
  },
  methods: {
    async handlePageChange(event) {
      this.currentPage = event.currentPage;

      this.direction = event.direction;
    }
  }
};
</script>
<style lang="scss">
.paginated-list {
  &-perPage {
    text-align: right;
    margin-bottom: 10px;

    * {
      display: inline-block;
    }

    span {
      margin-right: 10px;
    }
  }

  &-row {
    height: 40px;
  }
}
</style>
